import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      onClick={toggleTheme}
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      title={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      className="
        relative w-[52px] h-[28px] rounded-full
        bg-gray-200 dark:bg-[#1d2d47]
        border border-gray-300/80 dark:border-[#263757]
        transition-all duration-300 cursor-pointer
        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#4f8ff8]/50
        hover:bg-gray-300 dark:hover:bg-[#263757]
      "
    >
      {/* Track icons */}
      <span className="absolute inset-0 flex items-center justify-between px-[7px] pointer-events-none">
        {/* Sun icon */}
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="text-amber-500 opacity-90">
          <circle cx="12" cy="12" r="5"/>
          <line x1="12" y1="1" x2="12" y2="3"/>
          <line x1="12" y1="21" x2="12" y2="23"/>
          <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
          <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
          <line x1="1" y1="12" x2="3" y2="12"/>
          <line x1="21" y1="12" x2="23" y2="12"/>
          <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
          <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
        </svg>
        {/* Moon icon */}
        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="text-indigo-400 opacity-90">
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
        </svg>
      </span>

      {/* Thumb */}
      <span
        className={`
          absolute top-[3px] w-[22px] h-[22px] rounded-full
          bg-white dark:bg-[#4f8ff8]
          shadow-sm border border-gray-200/80 dark:border-[#6366f1]/30
          transition-all duration-300 ease-spring
          ${isDark ? 'left-[calc(100%-25px)]' : 'left-[3px]'}
        `}
      />
    </button>
  );
}
